
import { HttpClient } from "./http";

class DisputedTransaction extends HttpClient {
    constructor() {
        super()
    }

    public async getDisputedCount(startDate: any, endDate: any) {
        return this.HTTP.get(`/fleet/dispute-transaction/status-count?start=${startDate}&end=${endDate}`)
    }
    public async getDisputetransaction(id: any) {
        return this.HTTP.get(`/fleet/transaction/disputed/${id}`)
    }
    public async addNotes(id: any, note: any) {
        return this.HTTP.post(`/fleet/complaint/${id}/notes`, note)
    }
    public async getNotes(id: any) {
        return this.HTTP.get(`/fleet/complaint/${id}/notes`)
    }
    public async getAttachmentList(id: any) {
        return this.HTTP.get(`/fleet/complaint/${id}/documents`)
    }
    public async getNoteList(id: any) {
        return this.HTTP.get(`/fleet/complaint/${id}/notes`)
    }
}

export const DisputedTranService = new DisputedTransaction();
